import { useState, useContext } from 'react';
import { useNavigate } from 'react-router-dom';
import { Modal, LoginModal } from './Subcomponents/Modal';
import { ResearchContext } from './ResearchContext';
import { BACKEND_URL, CLIENT_AUTH_SECRET } from '../secrets';
import './AccountRemoval.css';

const AccountRemoval = () => {
    const navigate = useNavigate();
    const { currentUser, isLoggedIn } = useContext(ResearchContext);
    
    const [showLoginModal, setShowLoginModal] = useState(false);
    const [showConfirmModal, setShowConfirmModal] = useState(false);
    const [showSuccessModal, setShowSuccessModal] = useState(false);

    const handleLoginClick = () => {
        setShowLoginModal(true);
    };

    const handleLoginClose = () => {
        setShowLoginModal(false);
        
        // If user successfully logged in, show confirmation modal
        if (currentUser.id) {
            setShowConfirmModal(true);
        }
    };

    const handleConfirmDelete = () => {
        setShowConfirmModal(false);
        handleDelete();
    };

    const handleDelete = async () => {
        try {
            await fetch(BACKEND_URL + "/remove_user_by_id", {
                method: 'POST',
                headers: {
                  'Authorization': `Bearer: ${CLIENT_AUTH_SECRET}`,
                  'Content-Type': 'application/json;charset=utf-8'
                },
                mode: 'cors',
                body: JSON.stringify({id: currentUser.id})
            }).then(response => {
                if (response.ok) {
                    setShowSuccessModal(true);
                    console.log("account deleted");
                } else {
                    console.log(response);
                }
            });
        } catch (err) {
            console.log(err);
        }
    };

    const handleSuccessClose = () => {
        setShowSuccessModal(false);
        navigate('/');
    };

    return (
        <div className="page-container">
            <div className="account-removal-container">
                <h1 className="page-title">Delete Account</h1>
                
                <div className="warning-section">
                    <div className="warning-icon">⚠️</div>
                    <h2>Warning: This Action Cannot Be Undone</h2>
                    <p>
                        Deleting your account will permanently remove:
                    </p>
                    <ul>
                        <li>Your user profile, username, and email</li>
                        <li>All facts you've created</li>
                        <li>Your achievements and XP progress</li>
                        <li>All associated account data</li>
                    </ul>
                    <p className="final-warning">
                        This action is <strong>permanent</strong> and cannot be reversed.
                    </p>
                </div>

                {!isLoggedIn ? (
                    <button 
                        className="delete-account-btn"
                        onClick={handleLoginClick}
                    >
                        Log In to Delete Account
                    </button>
                ) : (
                    <div className="logged-in-section">
                        <p className="current-user-info">
                            Currently logged in as: <strong>{currentUser?.username}</strong>
                        </p>
                        <button 
                            className="delete-account-btn"
                            onClick={() => setShowConfirmModal(true)}
                        >
                            Delete My Account
                        </button>
                    </div>
                )}

                <button 
                    className="cancel-btn"
                    onClick={() => navigate('/')}
                >
                    Cancel - Return to Map
                </button>
            </div>

            <LoginModal 
                show={showLoginModal} 
                onClose={handleLoginClose}
            />

            <Modal
                show={showConfirmModal}
                title="Final Confirmation"
                message={`Are you absolutely sure you want to delete your account "${currentUser?.username}"? This will permanently delete all your data and cannot be undone.`}
                warningLevel={1}
                onClose={() => setShowConfirmModal(false)}
                action={handleConfirmDelete}
                actionText="Yes, Delete Everything"
                actionClass="modal-btn-delete"
            />

            <Modal
                show={showSuccessModal}
                title="Account Deleted"
                message="Your account and all associated data have been permanently deleted."
                warningLevel={2}
                onClose={handleSuccessClose}
            />
        </div>
    );
};

export default AccountRemoval;